export const PosFilters = {
    SET_INFO: 'IN_MEMORY.POS.SET_INFO',
};

export const setInfo = (name, country, company, address) => ({
    type: PosFilters.SET_INFO,
    name, country, company, address
});
